import CartDeliveryNote from "../info/CartDeliveryNote";
import CartSummary from "../info/CartSummary";
import CartDeliveryMessage from "../info/CartDeliveryMessage";
import CartOrder from "../input/CartOrder";
import CartPayment from "../input/CartPayment";
import LoadingDialog from "../../../general/dialog/DialogLoading";
import CartCheckoutButton from "../input/CartCheckoutButton";
import CartCheckoutError from "../info/CartCheckoutError";
import CartPaymentProcessor from "../input/CartPaymentProcessor";
import CartDelivery from "../input/CartDelivery";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import CartDiscounts from "../info/CartDiscounts";

const UpdatingDialog = () => {
    const loading = useCheckoutStore(state => state.loading?.cart);
    return <LoadingDialog title="Updating Order" loading={loading} />
}

const CompletingDialog = () => {
    const loading = useCheckoutStore(state => state.loading?.complete);
    return <LoadingDialog title="Completing Checkout" loading={loading} />
}

const CheckoutDeliveryNote = () => {
    const pickUpRule = useCheckoutStore(state => state.order?.deliveryViaRule?.id);
    const forPickUp = pickUpRule === 'P';
    return <CartDeliveryNote forPickUp={forPickUp} />
}

const CartCheckout = ({ checkout }) => {

    return (
        <div className="cart-container">
            <CartPaymentProcessor />
            <CartCheckoutError />
            <CompletingDialog />
            <UpdatingDialog />
            <div className="cart-header">
                <p className="cart-h1">Checkout</p>
                <CheckoutDeliveryNote />
            </div>
            <div className="cart-content">
                <div className="cart-column">
                    <div className="cart-section">
                        <p className="cart-h2">Order</p>
                        <CartOrder />
                    </div>
                    <div className="cart-section">
                        <p className="cart-h2">Delivery</p>
                        <CartDelivery />
                    </div>
                    <div className="cart-section">
                        <p className="cart-h2">Payment</p>
                        <CartPayment checkout={checkout} />
                    </div>
                </div>

                <div className="cart-column">
                    <div className="cart-section">
                        <p className="cart-h2">Summary</p>
                        <CartSummary />
                    </div>
                    <CartDiscounts />
                    <div className="cart-delivery">
                        <p className="cart-h2">Delivery Charge</p>
                        <CartDeliveryMessage checkout={checkout} />
                    </div>
                    <p className="cart-h2">Checkout</p>
                    <CartCheckoutButton
                        checkout={checkout}
                    />
                </div>
            </div>
        </div>
    )
}

export default CartCheckout;
